import styled from 'styled-components'
import TitleColumn from 'components/common/titleColumn'
import { PaddingContainer, GridMixin, AutoSwiper } from 'components/common/common_styles'
import DayNightIcons from 'components/common/dayNightIcons'
import { LinkButton } from 'components/common/typography'
import { sizeMobile, gutter } from 'components/globalStyles'

export const MainContainer = styled(PaddingContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: fit-content;

  @media (max-width: ${sizeMobile}) {
    width: 100%;
  }
`

export const UpperContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;

  @media (max-width: ${sizeMobile}) {
    flex-direction: column;
    gap: 16px;
    padding: 0 ${gutter};
  }
`

export const TextContainer = styled(TitleColumn)`
  align-self: flex-start;
  padding-bottom: 24px;
`

export const ImageContainer = styled.div`
  ${GridMixin};
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: auto auto;
  grid-auto-flow: column;
  column-gap: 16px;
  row-gap: 16px;
  justify-items: center;
`

export const DayNightIconContainer = styled(DayNightIcons)`
  align-self: end;
`

export const LodgingButton = styled(LinkButton)`
  @media (max-width: ${sizeMobile}) {
    margin: 0 ${gutter};
    width: calc(100% - 2 * ${gutter});
  }
`

export const Carousel = styled(AutoSwiper)`
  width: 100%;
`

export const PaginationContainer = styled.div`
  width: 100%;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
`